export const OTTERFOLIO_THEME = {
  bg: "#0E2A22",
  cardBg: "rgba(236, 220, 192, 0.04)",
  cardBorder: "rgba(76, 175, 110, 0.2)",
  primary: "#4CAF6E",
  deep: "#2E7D4F",
  highlight: "#FFC02E",
  otterBrown: "#8B5E3C",
  otterDark: "#5E3F27",
  beige: "#ECDCC0",
  text: "#F4F3EC",
  textMuted: "rgba(244, 243, 236, 0.5)",
  labelMuted: "rgba(244, 243, 236, 0.4)",
  // Fels/Rakete-Aliase fuer das 16-Positionen-Kachel-Redesign — beziehen sich
  // auf die bestehenden Kategorie-Farben, damit Kacheln, Overlay-Linien und
  // KpiStrip konsistent bleiben.
  fels: "#8B5E3C",
  rakete: "#FFC02E",
} as const;

export const DONUT_COLORS = [
  OTTERFOLIO_THEME.primary,
  OTTERFOLIO_THEME.deep,
  OTTERFOLIO_THEME.highlight,
  OTTERFOLIO_THEME.otterBrown,
  OTTERFOLIO_THEME.beige,
  OTTERFOLIO_THEME.otterDark,
] as const;

export const CATEGORY_COLORS: Record<"FELS" | "RAKETE" | "UNCATEGORIZED", string> = {
  FELS: OTTERFOLIO_THEME.otterBrown,
  RAKETE: OTTERFOLIO_THEME.highlight,
  UNCATEGORIZED: OTTERFOLIO_THEME.otterDark,
} as const;
